// Copyright (c) 2020-2026 Life and Soft

import axios from "axios";
import { jwtDecode } from "jwt-decode";

import setAuthToken from "../setAuthToken";
import { setCurrentUser } from "../../actions/authActions";
import { initConfiguration } from "../../actions/configurationsActions";

function createInstance() {
  const api_url =
    process.env.NODE_ENV === "production"
      ? `${window._env_.SERVER_HOST}:${window._env_.SERVER_PORT}/api`
      : "http://localhost:3000/api";

  let instance = axios.create({
    baseURL: api_url,
    withCredentials: true,
    responseType: "json",
    headers: {
      Authorization: localStorage.getItem("jwtToken"),
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("jwtToken");
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(undefined, (err) => {
    if (err?.response?.data?.name === "TokenExpiredError") {
      let refreshToken = localStorage.getItem("refreshToken");

      if (refreshToken) {
        setAuthToken(refreshToken);

        axios
          .get(api_url + "/users/refreshToken")
          .then((res) => {
            if (res.data.token === "no_refresh_token") {
              // update property
              axios.put(api_url + "/users/logout", res.data.userId);
              // Remove token from local storage
              localStorage.removeItem("jwtToken");
              localStorage.removeItem("refreshToken");
              // Remove auth header for future requests
              setAuthToken(false);
              initConfiguration({});
              setCurrentUser({});

              window.location.reload(false);
            } else {
              const { token, refreshToken } = res.data;

              localStorage.setItem("jwtToken", token);
              localStorage.setItem("refreshToken", refreshToken);
              // Set token to Auth header
              setAuthToken(token);

              // Decode token to get user data
              const decoded = jwtDecode(token);

              // Set current user
              setCurrentUser(decoded);

              axios
                .get(api_url + "/configuration")
                .then((res) => initConfiguration(res.data))
                .catch(() => console.log("Unable to load configuration"));
            }
          })
          .catch((err) => console.log(err));
      }
    }
    return Promise.reject(err);
  });

  return instance;
}

export default createInstance();
export { createInstance };
